module.exports = __webpack_public_path__ + "static/media/age_0.36005d4f.svg";